import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { WindowService } from '../window.service';
import { HttpClient } from '@angular/common/http';
import { ImageAsDataUrl } from './image-as-data-url';
import { Observable } from 'rxjs';
import { OeAppService } from '../oe-app.service';
import { OeAppPersonService } from '../oe-app-person.service';

@Injectable()
export class ImageUtilService {
  constructor(
    private windowService: WindowService,
    private httpClient: HttpClient,
    private readonly oeAppService: OeAppService,
    private readonly oeAppPersonService: OeAppPersonService
  ) {}

  createImageFromBlob(image: ImageAsDataUrl, blob: Blob) {
    const reader = this.windowService.getNewFileReader();
    reader.addEventListener(
      'load',
      () => {
        image.image = reader.result;
      },
      false
    );
    if (blob) {
      reader.readAsDataURL(blob);
    }
  }

  getProfilePic(height: number, width: number, id?: number) {
    const profilePicUrl = id ? `/profile/image/${width}/${height}/${id}` : `/profile/image/${width}/${height}`;
    return this.httpClient.get(profilePicUrl, { responseType: 'blob' }).pipe(
      map((response) => {
        return new Blob([response], { type: 'image/jpeg' });
      })
    );
  }

  getProfilePicByUuid(height: number = 50, width: number = 50, uuid?: string) {
    const personUuid = uuid ? uuid : this.oeAppPersonService.uuid;

    const downloadRequest = {
      key: `profile-images/${personUuid}/original.jpeg`,
      edits: {
        resize: {
          width,
          height,
          fit: 'cover',
        },
      },
    };
    const imageRequest = JSON.stringify(downloadRequest);
    const encodedImageRequest = btoa(imageRequest);
    const imageUrl = `${this.oeAppService.oeProfileImagesHost}/${encodedImageRequest}`;

    return this.httpClient.get(imageUrl, { responseType: 'blob' }).pipe(
      map((response) => {
        return URL.createObjectURL(response);
      })
    );
  }

  getProfilePicAsDataUrl(
    image: ImageAsDataUrl,
    height: number,
    width: number,
    id?: number
  ): Observable<ImageAsDataUrl> {
    return this.getProfilePic(height, width, id).pipe(
      map((response) => {
        this.createImageFromBlob(image, response);
        return image;
      })
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/image-util-service/image-util.service.ts